/**
 * The API's per-attribute error details can carry an inline link — "This id is
 * already in use, please use another id or <a href="…">update the matching
 * profile</a>." — so a detail is split into text and link segments rather than
 * rendered as HTML.
 */
export type ServerMessageSegment = { type: 'text'; text: string } | { type: 'link'; text: string; href: string };

const ANCHOR_PATTERN = /<a\s[^>]*?href="([^"]*)"[^>]*>([\s\S]*?)<\/a>/gi;

export function parseServerMessage(detail: string): ServerMessageSegment[] {
  const segments: ServerMessageSegment[] = [];
  let lastIndex = 0;

  for (const match of detail.matchAll(ANCHOR_PATTERN)) {
    const [anchor, href = '', text = ''] = match;
    const start = match.index;
    if (start > lastIndex) {
      segments.push({ type: 'text', text: detail.slice(lastIndex, start) });
    }
    segments.push({ type: 'link', text, href });
    lastIndex = start + anchor.length;
  }

  if (lastIndex < detail.length) {
    segments.push({ type: 'text', text: detail.slice(lastIndex) });
  }

  return segments;
}
